
<section class="breadcrumb-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="breadcrumb-title">
            <h1>404</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
    <ul class="breadcrumb">
      <li><a href="#">404</a></li>
      <li><i class="fa fa-angle-double-right"></i></li>
      <li>404</li>
    </ul>
  <section class="section-lg std-scholarship">
    <div class="container">
        <div class="row flex-row-reverse justify-content-center">
            <div class="col-md-6">
              <div class="sec-title text-center" >
                <h2>4<span>0</span>4</h2>
                <div class="text-line"></div>
              </div>
              <div class="text-center" >
                <h3>Oops,This Page Not Be Found!</h3>
                <p>We are really sorry but the page you requested is missing </p>
                <div class="text-center mt-3">
                  <a class="button-text" routerLink="/">Go Back to Home</a>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="text-center" >
                <img src="assets/images/404.webp" class="img-fluid" alt="404 | Ghrcacsn" title="404| Ghrcacsn">
              </div>
            </div>
          </div>
    </div>
  </section>
  